module.exports = __webpack_public_path__ + "img/foam.b0cd2b73.png";